import { createAction } from 'redux-actions'

export const setFundId = createAction('SET_DONATION_FUND_ID')
export const setLevel = createAction('SET_DONATION_AMOUNT')
export const setOrder = createAction('SET_DONATION_ORDER')
export const setGiftCard = createAction('SET_GIFT_CARD')
export const clearGiftCard = createAction('CLEAR_GIFT_CARD')
export const clearSelectedFund = createAction('CLEAR_SELECTED_FUND')
